/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import React from "react"
import "./src/styles/global.css";
import "./src/styles/style.css";
const { CartProvider } = require("./src/context/CartContext")

export const wrapRootElement = ({ element }) => (
    <CartProvider>{element}</CartProvider>
)